export default {
  /**
   * @type {[]}
   */
  prefix:              ['fw-control-bind', 'fw-bind'],
  /**
   * Array contenente i nomi dei componenti che possono essere disabilitati.
   * Questo elenco verr� usato in seguito per capire se il componente che si cerca di disabilitare o nascondere pu�
   * essere disabilitato. Se questo � falso, cerca i componenti al suo interno che possano essere disabilitati.
   *
   * @type {{string[]}}
   */
  disableableElements: ['input', 'textarea', 'button', 'select'],
  
  requireableElements: ['input', 'textarea', 'select']
};
